import React from "react"
import { clBasic, Scrudo } from "./general"
import Tarea from "./Tarea"

export default function Tareas({ tareas, grupo }) {

    let colorCelda = {
        Prioritarias: "#F5D0A9", "15 dias": "#F3F781", "Mediano plazo": "#D0F5A9"
    }

    return (
        <div style={Scrudo}>
            <div style={{ ...Stitulo, background: colorCelda[grupo] }}>{grupo}</div>
            <div style={Slista}>
                {tareas.map(t => <div key={t.id + t.proyecto} style={Sitem}><Tarea t={t} /></div>)}
            </div>
        </div >
    )
}

const Slista = {
    width: "25vw",
    maxHeight: "76vh",
    overflowY: "auto",
}

const Stitulo = {
    fontSize: "2.7vh",
    fontWeight: 700,
    marginBottom: "15px",
    padding: "10px 0px 10px 0px",
    textAlign: "center",
    color: clBasic
}

const Sitem = {
    color: "#424242",
    marginBottom: "10px",
    borderRadius: "5px"
}


